import axios from 'axios';

const baseURL = localStorage.getItem('authdb');
// const baseURL = "http://localhost:8000/"

// const baseURL = $store.state.authdb;

const instance = axios.create({
  baseURL: baseURL + 'api/'
})

export default instance
